"use client";

import { Icon } from "@iconify/react/dist/iconify.js";
import Image from "next/image";
import React from "react";

import styles from "./enroll-modal.module.scss";
import assets from "@/assets/images";

function EnrollModal({ onConfirm, onCancel }) {
  return (
    <section className={styles["container"]}>
      <aside className={styles["left"]}>
        <Image
          src={assets.EnrollModalImage}
          alt="test-image"
          width={500}
          height={500}
        />
        <a
          href="https://cs.cipherschools.com"
          target="_blank"
          rel="noopener noreferrer"
          className={styles["upgrade-btn"]}
        >
          UPGRADE
        </a>
        <p>to PRO</p>
      </aside>
      <aside className={styles["right"]}>
        <h2>Woo-hoo! 🔥 You're officially enrolled in the FREE program 🚀</h2>
        <hr className={styles.horizontalLine} />

        <ul>
          <li>
            This <span>Summer</span> Upgrade to <span>Pro</span> with{" "}
            <span>Summer Training Programs</span>
          </li>
          <li>
            <span>Be certified, verified,</span> and{" "}
            <span>glorified faster.</span>{" "}
          </li>
          <li>
            Upgrade now for <span>Summer Training</span> with{" "}
            <span>real projects, fast certs</span> &
            <span> internship-ready skills.</span>
          </li>
        </ul>
        <div className={styles["action-btns"]}>
          <a
            href="https://cs.cipherschools.com"
            target="_blank"
            rel="noopener noreferrer"
            className={styles["explore-stp-btn"]}
          >
            Explore STP 2025 <Icon icon="bi:arrow-right" />
          </a>
          <button onClick={onConfirm} className={styles["enroll-btn"]}>
            Continue to Enroll
          </button>
        </div>
      </aside>
    </section>
  );
}

export default EnrollModal;
